import { Footer } from '@components';
import { useGlobalGameState } from '@/providers/CoverStoryContext';
import { usePathname } from 'next/navigation';

interface ConditionalFooterProps {
  footerSettings: FooterSettings;
  isCoverStoryTemplate: boolean;
  isRockHallTv: boolean;
}

export default function ConditionalFooter({ footerSettings, isCoverStoryTemplate, isRockHallTv }: ConditionalFooterProps) {
  const gameState = useGlobalGameState();
  const pathname = usePathname();

  // Check if we're on an individual game page (not the landing page)
  const isGamePage = isCoverStoryTemplate && pathname !== '/cover-story';

  // Hide footer for Rock Hall TV always
  if (isRockHallTv) return null;

  // On individual game pages: hide footer only while playing
  // Show footer after game over (won/lost) and on landing page
  if (isGamePage && gameState === 'playing') return null;

  return <Footer {...footerSettings} />;
}
